import Vue from 'vue';

var bus = new Vue();

bus.$listen = function(name, callback)
{
    if (bus._events[name])
    {
        bus.$off(name);
    }

    bus.$on(name, callback);
}

export default bus;



// WEBPACK FOOTER //
// ./src/js/events/events.js